module.exports = {
    LABOR_SCREENING_CONCLUSION: {
        NOT_ENOUGH_INFO: '0',
        LEVEL1: '1',
        LEVEL2: '2'
    },
    LABOR_SCREENING_PREFIX: {
        PRELIM: 'prelim_',
        ENDS: 'e_',
        MEANS: 'm_',
        PROCESS: 'p_'
    },
    LABOR_CONCLUSION_LABEL_MAP: {
        '0': 'Not Enough Information',
        '1': 'Level 1: Concern',
        '2': 'Level 2: Indicated'
    },
    OLD_TRAFFICKING_SCREENING_CONCLUSION_ENUM: {
        NOT_ENOUGH_INFO: '0',
        CONCERN: '1',
        INDICATED: '2'
    },

    OLD_TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP: {
        '0': 'Not Enough Information',
        '1': 'Concern',
        '2': 'Indicated'
    },
    TRAFFICKING_SCREENING_CONCLUSION_ENUM: {
        NOT_ENOUGH_INFO: '0',
        LEVEL1: '1',
        LEVEL2: '2'
        // CONCERN: '1',
        // INDICATED: '2'
    },
    TRAFFICKING_SCREENING_PREFIX: {
        PRELIM: 'prelim_',
        ONE: 'one_',
        TWO: 'two_',
        THREE: 'three_'
    },
    TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP: {
        '0': 'Not Enough Information',
        '1': 'Concern',
        '2': 'Indicated'
    },
    ANNUAL_DATA_TABLE_HEADER: [
        'Person ID',
        'Victim Initials',
        'Date of Birth',
        'Age',
        'Approximate Age',
        'Gender',
        'Sexual Orientation',
        'Race',
        'Ethnicity',
        'Education Level',
        'Disability',
        'Immigration Status',
        'Location of Trafficking Incident',
        'Trafficking - Multiple (Primary)',
        'Trafficking - Out of State',
        'Trafficking - Out of State (City)',
        'Trafficking - Out of Country',
        'Location of Origin',
        'Origin - Out of State',
        'Origin - Out of State (City)',
        'Origin - Out of Country',
        'Trafficking Type',
        'Victim Status',
        'Program Entry Date',
        'Program Discharge Date',
        'Discharge Reason',
        'Health',
        'Mental Health',
        'Housing',
        'Education',
        'Job Training',
        'Child Care',
        'Victim Compensation',
        'Legal Services',
        'Referral to Community Services',
        'Family Unification',
        'Apply for Federal/State Benefits',
        'Multidisciplinary Team Staffing',
        'Forensic Interview',
        'Addiction Recovery Services',
        'Safety Planning',
        'Budget or Financial Literacy',
        'Parenting or Pregnancy Services',
        'Translation or ESL Services',
        'Victim Advocacy',
        'Transportation',
        'Food/Clothing/Hygiene',
        'Other Financial Assistance',
        'Personal Documents Assistance',
        'Mentorship',
        'Case Management',
        'Other Services'
    ],
    ANNUAL_DATA_DATE_FIELDS: [
        'Date of Birth',
        'Program Entry Date',
        'Program Discharge Date'
    ],
    USER_REPORT_HEADER: [
        'User Name',
        'User Email',
        'User Access Level',
        'Date of Last Login',
        'Number of Person Records',
        'Number of CSE-IT Screenings',
        'Number of Clear Concern CSE-IT Screenings',
        'Date of Last Person Record',
        'Date of Last CSE-IT'
    ],
    USER_REPORT_HEADER_LA: [
        'User Name',
        'User Email',
        'User Access Level',
        'Date of Last Login',
        'Number of Person Records',
        'Number of CSE-IT Screenings',
        'Number of Clear Concern CSE-IT Screenings',
        'Number of Labor Screenings',
        'Date of Last Person Record',
        'Date of Last CSE-IT'
    ],
    LIMIT: {
        FIND: 1000,
        NUM_OF_RECURSIVE_CALLS: 4
    },
    NUM_OF_RECORDS_PER_PAGE: 20,
    GLOBAL_REPORTS_TAB_INDEX: {
        DEMOGRAPHICS: 0,
        CSEIT: 1,
        ASSESSMENT: 2,
        LABOR_SCREENING: 3
    },
    STATISTICS_TAB_INDEX: {
        DEMOGRAPHICS: 0,
        CSEIT: 1,
        ASSESSMENT: 2,
        LABOR_SCREENING: 3
    }
}



// WEBPACK FOOTER //
// ./src/helpers/enums.js